import { render, staticRenderFns } from "./Classifica.vue?vue&type=template&id=39a11f5e&scoped=true"
import script from "./Classifica.vue?vue&type=script&lang=js"
export * from "./Classifica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a11f5e",
  null
  
)

export default component.exports